module.exports = __webpack_public_path__ + "static/media/img-cannot-view-narrator.17eb2cf5.png";